// extracted by mini-css-extract-plugin
module.exports = {"accordion-wrapper":"AccordionSection_accordion-wrapper__dZR_d"};